import { forwardRef, type InputHTMLAttributes } from "react";

interface FInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
  hint?: string;
}

export const FInput = forwardRef<HTMLInputElement, FInputProps>(function FInput(
  { label, error, hint, className = "", id, ...rest },
  ref,
) {
  const inputId = id || rest.name;
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-[13px] mb-1.5 text-[var(--colour-text-secondary)]"
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={[
          "w-full min-h-[44px] px-3.5 text-[15px]",
          "bg-[var(--colour-surface)] text-[var(--colour-text-primary)]",
          "border border-[var(--colour-border)] rounded-[var(--radius-sm)]",
          "outline-none focus:border-[var(--colour-accent)]",
          "placeholder:text-[var(--colour-text-secondary)]",
          className,
        ].join(" ")}
        {...rest}
      />
      {error ? (
        <p className="mt-1 text-[12px] text-red-500">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-[12px] text-[var(--colour-text-secondary)]">{hint}</p>
      ) : null}
    </div>
  );
});
